import { l as _inherits, a as _createClass, e as _objectSpread2, b as _classCallCheck, m as _callSuper, _ as _slicedToArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import React__default, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { C as Card } from './Card-683c5834.js';
import Image from './Image.js';
import Title from './Title.js';
import Icon from './Icon.js';
import MapView from './MapView.js';
import Location from './Location.js';
import AmenitiesList from './AmenitiesList.js';
import Description from './Description.js';
import Price from './Price.js';
import { B as Button } from './Button-9db40655.js';
import LoadingBlock from './LoadingBlock.js';
import PropertyRating from './PropertyRating.js';
import Modal from './Modal.js';
import { r as renderStars } from './utilsHelpers-21a239d9.js';
import { h as handleOpenLink } from './handleOpenLink-49ba3691.js';
import { F as FormattedDate, a as FormattedNumber } from './index-c101e2b0.js';
import Divider from './Divider.js';
import { b as alternativeOffersShape, n as nodeOrStringProp, f as formattedSearchParamsShape, c as currencyShape, m as mainImageShape, t as trustYouProfileDataShape } from './PropTypes-9aad034b.js';
import { I as IntlProvider } from './provider-b3aa55fe.js';

// eslint-disable-next-line import/prefer-default-export
var alternativeOffersLabelsShape = PropTypes.shape({
  show: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  hide: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  getTitleWithHotel: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  getCheckIn: PropTypes.func,
  getStartingFrom: PropTypes.func
});

var AlternativeOffers = /*#__PURE__*/function (_React$Component) {
  function AlternativeOffers() {
    _classCallCheck(this, AlternativeOffers);
    return _callSuper(this, AlternativeOffers, arguments);
  }
  _inherits(AlternativeOffers, _React$Component);
  return _createClass(AlternativeOffers, [{
    key: "handleBookNowClick",
    value: function handleBookNowClick(offer) {
      var _this$props = this.props,
        getQueryString = _this$props.getQueryString,
        params = _this$props.params,
        newTabDisabled = _this$props.newTabDisabled,
        domain = _this$props.domain,
        propertyCode = _this$props.propertyCode;
      var query = getQueryString(_objectSpread2(_objectSpread2({}, params), {}, {
        'skd-checkin': offer.checkIn,
        'skd-checkout': offer.checkOut
      }));
      var url = "http://".concat(domain, "/property/").concat(propertyCode).concat(query);
      handleOpenLink(url, newTabDisabled);
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader() {
      var _this$props2 = this.props,
        alternativeOffers = _this$props2.alternativeOffers,
        priceDisplayMode = _this$props2.priceDisplayMode,
        labels = _this$props2.labels;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: "table-col align-left table-header"
      }, labels.getCheckIn(alternativeOffers[0].los)), /*#__PURE__*/React__default.createElement("div", {
        className: "table-col align-right table-header"
      }, labels.getStartingFrom(priceDisplayMode)), /*#__PURE__*/React__default.createElement("div", {
        className: "table-col booknow-button"
      }));
    }
  }, {
    key: "renderAlternativeOffer",
    value: function renderAlternativeOffer(offer, idx) {
      var _this = this;
      var _this$props3 = this.props,
        buttonMessage = _this$props3.buttonMessage,
        currency = _this$props3.currency,
        currencyDisplay = _this$props3.currencyDisplay,
        fractionDigits = _this$props3.fractionDigits;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "alternativeOffer_".concat(idx)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "table-col"
      }, /*#__PURE__*/React__default.createElement(FormattedDate, {
        value: offer.checkIn
        // @ts-ignore
        ,
        shortDate: true,
        completeDate: true
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "table-col align-right"
      }, /*#__PURE__*/React__default.createElement(FormattedNumber, {
        value: offer.price,
        currency: currency,
        currencyDisplay: currencyDisplay,
        fractionDigits: fractionDigits
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "table-col booknow-button"
      }, /*#__PURE__*/React__default.createElement(Button, {
        secondary: true,
        size: "small",
        fluid: true,
        content: buttonMessage,
        className: "bf-property-card-selection-button",
        onClick: function onClick() {
          return _this.handleBookNowClick(offer);
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        language = _this$props4.language,
        alternativeOffers = _this$props4.alternativeOffers,
        showTitle = _this$props4.showTitle,
        labels = _this$props4.labels;
      return /*#__PURE__*/React__default.createElement(IntlProvider, {
        locale: language
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "bf-property-card-alternative-offers"
      }, showTitle ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Title, {
        content: labels.title,
        size: "normal"
      })) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "alternative-offers-table"
      }, this.renderTableHeader(), alternativeOffers.map(function (offer, idx) {
        return _this2.renderAlternativeOffer(offer, idx);
      }))));
    }
  }]);
}(React__default.Component);
AlternativeOffers.defaultProps = {
  language: 'EN',
  alternativeOffers: [],
  getQueryString: function getQueryString() {},
  priceDisplayMode: '',
  buttonMessage: '',
  params: {},
  newTabDisabled: false,
  currency: {
    code: 'USD',
    symbol: '$'
  },
  currencyDisplay: 'code',
  fractionDigits: 2,
  showTitle: true
};
AlternativeOffers.propTypes = {
  language: PropTypes.string,
  alternativeOffers: PropTypes.arrayOf(alternativeOffersShape),
  labels: alternativeOffersLabelsShape.isRequired,
  getQueryString: PropTypes.func,
  priceDisplayMode: nodeOrStringProp,
  buttonMessage: nodeOrStringProp,
  params: PropTypes.shape(formattedSearchParamsShape),
  newTabDisabled: PropTypes.bool,
  propertyCode: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  currency: PropTypes.shape(currencyShape),
  currencyDisplay: PropTypes.string,
  fractionDigits: PropTypes.number,
  showTitle: PropTypes.bool
};

function PropertyCard(props) {
  var className = props.className,
    images = props.images,
    mainImage = props.mainImage,
    name = props.name,
    stars = props.stars,
    location = props.location,
    amenities = props.amenities,
    description = props.description,
    isLoading = props.isLoading,
    displayMode = props.displayMode,
    onClose = props.onClose,
    price = props.price,
    originalPrice = props.originalPrice,
    fractionDigits = props.fractionDigits,
    currency = props.currency,
    currencyDisplay = props.currencyDisplay,
    discount = props.discount,
    isNotAvailable = props.isNotAvailable,
    hasPropertyRating = props.hasPropertyRating,
    onClick = props.onClick,
    params = props.params,
    domain = props.domain,
    getQueryString = props.getQueryString,
    code = props.code,
    trustYouProfile = props.trustYouProfile,
    buttonMessage = props.buttonMessage,
    styledPrice = props.styledPrice,
    priceMessages = props.priceMessages,
    reviewsCountMessage = props.reviewsCountMessage,
    reviewsModalTitleMessage = props.reviewsModalTitleMessage,
    alternativeGridMode = props.alternativeGridMode,
    showPrices = props.showPrices,
    newTabDisabled = props.newTabDisabled,
    closeIcon = props.closeIcon,
    userCountry = props.userCountry,
    isQA = props.isQA,
    hidePrices = props.hidePrices,
    hidePricesMessage = props.hidePricesMessage,
    language = props.language,
    alternativeOffers = props.alternativeOffers,
    alternativeOffersLabels = props.alternativeOffersLabels,
    mapProvider = props.mapProvider,
    intl = props.intl;
  var propertyCardRef = useRef();
  var propertyImageRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    propertyImageHeight = _useState2[0],
    setPropertyImageHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    propertyCardWidth = _useState4[0],
    setPropertyCardWidth = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    alternativeOffersVisible = _useState6[0],
    setAlternativeOffersVisible = _useState6[1];
  var _useState7 = useState(!isLoading),
    _useState8 = _slicedToArray(_useState7, 2),
    loadAnimation = _useState8[0],
    setLoadAnimation = _useState8[1];
  var queryParams = getQueryString(params);
  var propertyUrl = "http://".concat(domain, "/property/").concat(code).concat(queryParams);
  var handleOnClick = function handleOnClick() {
    return !onClick ? handleOpenLink(propertyUrl, newTabDisabled) : onClick(code, params);
  };
  var getImageHeight = function getImageHeight(width) {
    return 9 * width / 16;
  }; // Keep 16:9 aspect ratio

  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    prevDisplayMode = _useState10[0],
    setPrevDisplayMode = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isComponentLoading = _useState12[0],
    setIsComponentLoading = _useState12[1];

  // Shows loading state when changing to list or grid view
  useEffect(function () {
    var timer;
    var shouldSetComponentLoading = prevDisplayMode !== null && prevDisplayMode !== displayMode && displayMode !== 'map';
    if (shouldSetComponentLoading) {
      setIsComponentLoading(true);
      timer = setTimeout(function () {
        setIsComponentLoading(false);
      }, 300);
    }
    setPrevDisplayMode(displayMode);
    return function () {
      return !shouldSetComponentLoading && !isComponentLoading && clearTimeout(timer);
    };
  }, [displayMode, prevDisplayMode, isComponentLoading]);

  // eslint-disable-next-line
  useEffect(function () {
    // Its called at the first render and after each component update.
    // Handle displayMode change and the screen resize
    if (propertyImageRef.current) {
      var currentImageWidth = propertyImageRef.current.clientWidth;
      setPropertyImageHeight(getImageHeight(currentImageWidth));
    }
    if (propertyCardRef.current) {
      var currentCardWidth = propertyCardRef.current.clientWidth;
      setPropertyCardWidth(currentCardWidth);
    }
  });
  useEffect(function () {
    setLoadAnimation(!isLoading && !isComponentLoading);
  }, [isLoading, isComponentLoading]);
  var showLocation = location && !isLoading && !isComponentLoading;
  var locationInfo = /*#__PURE__*/React__default.createElement(Location, {
    location: location,
    className: "bf-property-card-location",
    showAsLink: displayMode !== 'map',
    hideIcon: displayMode !== 'map' || alternativeGridMode
  });
  var propertyCardMapModal = /*#__PURE__*/React__default.createElement(MapView.Modal, {
    mapProvider: mapProvider,
    location: location,
    triggerText: locationInfo,
    modalTitle: name,
    modalSize: "large",
    userCountry: userCountry,
    isQA: isQA
  });
  var propertyCardName = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-name-wrapper"
  }, (isLoading || isComponentLoading) && (displayMode !== 'grid' || alternativeGridMode) ? /*#__PURE__*/React__default.createElement(LoadingBlock, {
    width: "75%",
    height: "30px"
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    className: "bf-property-card-name",
    content: name,
    size: "large",
    onClick: handleOnClick
  }), stars ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-stars-wrapper"
  }, renderStars(stars)) : null)), showLocation && displayMode === 'grid' ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-location-wrapper"
  }, propertyCardMapModal) : null);
  var PropertyRatingWidget = function PropertyRatingWidget(alignment) {
    return trustYouProfile ? /*#__PURE__*/React__default.createElement(PropertyRating, {
      score: parseInt(trustYouProfile.score, 10),
      qualification: trustYouProfile.score_description,
      reviewsCount: trustYouProfile.reviews_count,
      scorePosition: alignment,
      reviewsCountMessage: reviewsCountMessage,
      reviewsModalTitleMessage: reviewsModalTitleMessage
    }) : null;
  };
  var showPropertyRatingInPropertyInfoWrapper = (propertyCardWidth <= 768 || displayMode === 'map') && !isLoading && !isComponentLoading;
  var showPropertyRatingInSelectionWrapper = (propertyCardWidth > 768 && displayMode === 'list' || displayMode === 'grid' && !alternativeGridMode) && !isLoading && !isComponentLoading;
  var showInformationWrapper = displayMode === 'grid' && (hasPropertyRating || alternativeGridMode) || displayMode !== 'grid';
  var showAmenities = amenities.length > 0 && !isLoading && !isComponentLoading && displayMode !== 'grid';
  var showDescription = description && (displayMode !== 'grid' || alternativeGridMode);
  var domAttributes = [{
    attribute: 'data-offer-path-nav',
    value: price
  }];
  var shouldShowPrice = !isNotAvailable && showPrices && price && !alternativeGridMode;
  var shouldShowAlternativeOffers = alternativeOffers.length && !isLoading && !isComponentLoading;
  var alternativeOffersLinkList = shouldShowAlternativeOffers ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-alternative-offers-link"
  }, /*#__PURE__*/React__default.createElement("a", {
    onClick: function onClick() {
      return setAlternativeOffersVisible(!alternativeOffersVisible);
    }
  }, alternativeOffersVisible ? alternativeOffersLabels.hide : alternativeOffersLabels.show)) : null;
  var getAlternativeOffersElement = function getAlternativeOffersElement(showTitle) {
    return /*#__PURE__*/React__default.createElement(AlternativeOffers, {
      language: language,
      alternativeOffers: alternativeOffers,
      labels: alternativeOffersLabels,
      getQueryString: getQueryString,
      priceDisplayMode: priceMessages.priceDisplayMode,
      buttonMessage: buttonMessage,
      params: params,
      newTabDisabled: newTabDisabled,
      propertyCode: code,
      domain: domain,
      currency: currency,
      currencyDisplay: currencyDisplay,
      fractionDigits: fractionDigits,
      showTitle: showTitle
    });
  };
  var alternativeOffersElement = shouldShowAlternativeOffers && alternativeOffersVisible ? getAlternativeOffersElement(true) : null;
  var alternativeOffersModal = shouldShowAlternativeOffers ? /*#__PURE__*/React__default.createElement(Modal, {
    trigger: /*#__PURE__*/React__default.createElement("a", {
      className: "bf-property-card-alternative-offers-link"
    }, alternativeOffersLabels.show),
    title: alternativeOffersLabels.getTitleWithHotel(name),
    content: getAlternativeOffersElement(false),
    size: "small"
  }) : null;
  return /*#__PURE__*/React__default.createElement(Card, {
    className: "bf-property-card\n                display-as-".concat(displayMode, "\n                ").concat(displayMode === 'list' && propertyCardWidth < 850 && propertyCardWidth > 768 ? 'smaller-columns' : '', "\n                ").concat(displayMode === 'list' && propertyCardWidth <= 768 ? 'avoid-columns' : '', "\n                ").concat(alternativeGridMode ? 'has-alternative-grid-mode-layout' : '', "\n                ").concat(isLoading || isComponentLoading ? 'is-loading' : '', "\n                ").concat(loadAnimation && displayMode !== 'map' ? 'trigger-load-animation' : '', "\n                ").concat(isNotAvailable ? 'is-not-available' : '', "\n                ").concat(className, "\n            "),
    noPadding: true,
    transparent: displayMode === 'map',
    ref: propertyCardRef
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-image-wrapper",
    style: {
      height: displayMode !== 'map' ? "".concat(propertyImageHeight, "px") : 'unset'
    }
  }, /*#__PURE__*/React__default.createElement(Image, {
    className: "bf-property-card-image",
    images: images,
    mainImage: _objectSpread2(_objectSpread2({}, mainImage), {}, {
      title: mainImage.title || name
    }),
    alt: intl.formatMessage({
      id: 'bf.openHotel',
      defaultMessage: 'bf.openHotel'
    }),
    fluid: true,
    ref: propertyImageRef,
    onClick: handleOnClick
  }), isLoading || isComponentLoading ? /*#__PURE__*/React__default.createElement(LoadingBlock, {
    height: "100%"
  }) : displayMode === 'grid' && !alternativeGridMode && /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-grid-layout-name-wrapper",
    onClick: onClick
  }, propertyCardName)), showInformationWrapper ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-information-wrapper"
  }, displayMode !== 'grid' || alternativeGridMode ? propertyCardName : null, showPropertyRatingInPropertyInfoWrapper ? PropertyRatingWidget('left') : null, showLocation && displayMode !== 'grid' ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-location-wrapper"
  }, displayMode === 'list' ? propertyCardMapModal : locationInfo) : null, showAmenities ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-amenities-wrapper"
  }, /*#__PURE__*/React__default.createElement(AmenitiesList, {
    amenities: amenities,
    className: "bf-property-card-amenities",
    isQA: isQA
  })) : null, showDescription ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-description-wrapper"
  }, isLoading || isComponentLoading ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LoadingBlock, null), /*#__PURE__*/React__default.createElement(LoadingBlock, null), /*#__PURE__*/React__default.createElement(LoadingBlock, {
    width: "50%"
  })) : /*#__PURE__*/React__default.createElement(Description, {
    content: /*#__PURE__*/React__default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: description
      }
    }),
    className: "bf-property-card-description",
    linesToShow: displayMode === 'list' || alternativeGridMode ? 4 : 2,
    dontExpand: displayMode === 'map'
  })) : null) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-selection-info-wrapper"
  }, displayMode === 'grid' && (isLoading || isComponentLoading) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement(LoadingBlock, {
    width: alternativeGridMode ? '100%' : '150px',
    height: "40px"
  })) : null, !isLoading && !isComponentLoading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showPropertyRatingInSelectionWrapper ? PropertyRatingWidget('right') : null, shouldShowPrice ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-price-wrapper"
  }, /*#__PURE__*/React__default.createElement(Price, {
    value: price,
    currency: currency,
    currencyDisplay: currencyDisplay,
    originalPrice: originalPrice,
    discount: discount,
    topPriceReference: priceMessages.startingFrom,
    bottomPriceReference: priceMessages.priceDisplayMode,
    fractionDigits: fractionDigits || 2,
    styled: styledPrice,
    className: "bf-property-card-price"
  })) : null, hidePrices ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-price-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bookeable-with-coupon-message"
  }, hidePricesMessage)) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-property-card-selection-button-wrapper"
  }, /*#__PURE__*/React__default.createElement(Button, {
    primary: true,
    fluid: true,
    content: buttonMessage,
    className: "bf-property-card-selection-button",
    onClick: handleOnClick,
    domAttributes: domAttributes
  }))), displayMode === 'list' && alternativeOffersLinkList, displayMode !== 'list' && alternativeOffersModal), displayMode === 'list' && alternativeOffersElement, displayMode === 'map' && closeIcon ? /*#__PURE__*/React__default.createElement("span", {
    className: "bf-property-card-in-map-layout-close-trigger-wrapper",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "bf-icon-times",
    size: "small",
    className: "bf-property-card-in-map-layout-close-trigger"
  })) : null);
}
PropertyCard.defaultProps = {
  className: '',
  name: '',
  images: [],
  stars: null,
  location: {},
  amenities: [],
  description: '',
  isLoading: false,
  displayMode: 'list',
  price: 0,
  originalPrice: 0,
  fractionDigits: 0,
  discount: 0,
  currency: {
    code: 'USD',
    symbol: '$'
  },
  currencyDisplay: 'code',
  onClick: function onClick() {},
  isNotAvailable: false,
  hasPropertyRating: false,
  onClose: function onClose() {},
  mainImage: {},
  domain: '',
  params: {},
  getQueryString: function getQueryString() {},
  trustYouProfile: null,
  styledPrice: false,
  priceMessages: {
    startingFrom: '',
    priceDisplayMode: ''
  },
  reviewsCountMessage: function reviewsCountMessage() {},
  reviewsModalTitleMessage: '',
  alternativeGridMode: false,
  newTabDisabled: false,
  closeIcon: true,
  userCountry: null,
  code: null,
  buttonMessage: '',
  isQA: false,
  hidePrices: false,
  hidePricesMessage: null,
  language: 'DE',
  alternativeOffers: [],
  alternativeOffersLabels: {
    show: 'Show Alternative Offers',
    hide: 'Hide Alternative Offers',
    getTitleWithHotel: function getTitleWithHotel(name) {
      return "Alternative Offers for ".concat(name);
    },
    title: 'Alternative Prices',
    getCheckIn: function getCheckIn(los) {
      return "Check In (".concat(los, " night stay)");
    },
    getStartingFrom: function getStartingFrom() {
      return 'Starting From (Total)';
    }
  }
};
PropertyCard.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Images array (objects with title and url)
   */
  images: PropTypes.arrayOf(mainImageShape),
  /**
  Main image (object with title and url)
   */
  mainImage: mainImageShape,
  /**
  Property name
   */
  name: nodeOrStringProp,
  /**
  Property stars qualification
   */
  stars: PropTypes.number,
  /**
  Property location (latitude, longitude, address, city, region, country)
   */
  location: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    address: PropTypes.string,
    city: PropTypes.string,
    region: PropTypes.string,
    country: PropTypes.string
  }),
  /**
  Property amenities array (objects with icon, defaultIcon and text)
   */
  amenities: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    defaultIcon: PropTypes.string,
    text: PropTypes.string.isRequired
  })),
  /**
  Property description
   */
  description: nodeOrStringProp,
  /**
  Property in loading state
   */
  isLoading: PropTypes.bool,
  /**
  Display card in list, grid or map mode
   */
  displayMode: PropTypes.oneOf(['list', 'grid', 'map']),
  /**
  Property price
   */
  price: PropTypes.number,
  /**
  Property original price (for discounts)
   */
  originalPrice: PropTypes.number,
  /**
  Discount percent
   */
  discount: PropTypes.number,
  /**
  Number of decimals in main price
   */
  fractionDigits: PropTypes.number,
  /**
  Price currency (code, symbol)
   */
  currency: PropTypes.shape(currencyShape),
  /**
  Show currency as code or symbol
   */
  currencyDisplay: PropTypes.string,
  /**
  Function triggered on property selection
   */
  onClick: PropTypes.func,
  /**
  Not available property
   */
  isNotAvailable: PropTypes.bool,
  /**
  Property has a valuation rating
   */
  hasPropertyRating: PropTypes.bool,
  /**
  Function triggered on close icon click (map displayMode)
   */
  onClose: PropTypes.func,
  /**
  Site domain
   */
  domain: PropTypes.string,
  /**
  Url params
   */
  params: PropTypes.shape(formattedSearchParamsShape),
  /**
  Function helper to get the redirect url
   */
  getQueryString: PropTypes.func,
  /**
  Property Code
   */
  code: PropTypes.string,
  /**
  Property trustYou profile
   */
  trustYouProfile: PropTypes.shape(trustYouProfileDataShape),
  /**
  Button intl message
   */
  buttonMessage: nodeOrStringProp,
  /**
  Show the price styled (currency, integer, decimal)
   */
  styledPrice: PropTypes.bool,
  /**
  Show the price messages
   */
  priceMessages: PropTypes.shape({
    /**
    Label above the price
     */
    startingFrom: nodeOrStringProp,
    /**
    Label under the price
     */
    priceDisplayMode: nodeOrStringProp
  }),
  /**
  Function for displaying reviews count
   */
  reviewsCountMessage: PropTypes.func,
  /**
  Reviews modal title
   */
  reviewsModalTitleMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
  Force alternative layout in grid mode (Echo)
   */
  alternativeGridMode: PropTypes.bool,
  /**
  Flag tho choose if to show price card or not.
   */
  showPrices: PropTypes.bool.isRequired,
  /** Opening new tab may be disabled by prop
   *
   */
  newTabDisabled: PropTypes.bool,
  /**
  Close icon on top right {true}
   */
  closeIcon: PropTypes.bool,
  userCountry: PropTypes.string,
  /**
   * This value is used for data-test-id
   */
  isQA: PropTypes.bool,
  hidePrices: PropTypes.bool,
  hidePricesMessage: PropTypes.node,
  language: PropTypes.string,
  alternativeOffers: PropTypes.arrayOf(alternativeOffersShape),
  alternativeOffersLabels: alternativeOffersLabelsShape,
  mapProvider: PropTypes.elementType.isRequired,
  intl: PropTypes.object.isRequired
};

export { PropertyCard as P, alternativeOffersLabelsShape as a };
